<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="fm03_hd">
<h1 class="h1" id="fm03_hd"><span aria-label=" page 2. " epub:type="pagebreak" id="page_2" role="doc-pagebreak">Los Angeles Times</span></h1>
<p class="sutxt">International Section, June 27, 1984</p>
<p class="indent">Tokyo police have given up the search for relatives of the lone survivor of the crash of Japan Airlines flight 999, which left 176 passengers dead two months ago. The eight-month-old baby girl, named “Heaven” by the American press for her amazing fall from the sky, is being kept in an undisclosed location….</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?069f9797